import { getSessionUser } from "./session";

export const isAdvancedUser = () => {
  const session = getSessionUser();

  return session?.type === "root";
};
